import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const Driver = (props) => {
  const LargeModaltoggle = () => {
    setname("")

    setmobilenumber("")

    setemail("")

    setlicensetype("")
    setlicenseno("")



    setaadharno("")
    setdob("")







    setLarge(!Large)
  };
  const [edittype, setedittype] = useState("")
  const [editid, seteditid] = useState("")
  const [Large, setLarge] = useState(false);
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [mobilenumber, setmobilenumber] = useState('')



  const [aadharno, setaadharno] = useState('')
  const [dob, setdob] = useState('')


  const [licensetype, setlicensetype] = useState("")
  const [licenseno, setlicenseno] = useState("")

  const [license_type, setlicense_type] = useState([])
  const [Driver_detail, setDriver_detail] = useState([])
  const [clientHeight, setclientHeight] = useState("")

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  useEffect(async () => {

    if (localStorage.getItem("usertype") != "Supplier") {
      window.history.back()
    }

    let { data: driver_license_type, error2 } = await supabase
      .from('driver_license_type')
      .select('*')

    if (error2 === undefined) {
      setlicense_type(driver_license_type)

    }


    getDriverdetail()
  }, [])

  async function getDriverdetail() {
    let { data: driver_details, error } = await supabase
      .from('driver_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))

    if (driver_details !== null && driver_details.length > 0) {
      setDriver_detail(driver_details)
      setTimeout(() => {
        setclientHeight(window.innerHeight * 0.71)

      }, 1000)
    } else {
      // toast.error("No Driver Details Found")
      setDriver_detail([])
    }
  }

  const randomUsername = () => {
    return `${Date.now().toString().substr(-4)}`;
  };
  const UpdateUser = async (Driverid) => {
    setLarge(!Large)
    setedittype("updated")
    seteditid(Driverid)
    let { data: driver_details, error } = await supabase
      .from('driver_details')
      .select('*')
      .eq('driver_id', Driverid)

    if (driver_details !== null && driver_details.length > 0) {
      setname(driver_details[0].driver_name)
      setmobilenumber(driver_details[0].driver_phone.toString().slice(2, 12))
      setemail(driver_details[0].driver_email)



      if (driver_details[0].driver_aadhar_no == null) {
        setaadharno("")
      } else {
        setaadharno(driver_details[0].driver_aadhar_no)
      }
      if (driver_details[0].driver_dob == "") {
        setdob("")
      } else {
        setdob(driver_details[0].driver_dob)
      }
      setlicenseno(driver_details[0].driver_licence)
      setlicensetype(driver_details[0].driver_licensetype)
    }
  }
  const DeleteUser = async (Driverid) => {
    let { data: user_Details, error1 } = await supabase
      .from('User_Details')
      .delete()
      .eq('user_id', Driverid)
    console.log(user_Details, error1)
    if (user_Details !== null && user_Details.length > 0) {
      let { data: driver_details, error } = await supabase
        .from('driver_details')
        .delete()
        .eq('driver_id', Driverid)
      console.log(driver_details, error)
      if (driver_details !== null && driver_details.length > 0) {

        toast.success("Driver Deleted Successfully")
        getDriverdetail()


      } else {
        toast.error("Error in Deleting Driver")
      }
    } else {
      toast.error("Error in Deleting Driver")
    }
  }
  const validatelicenseno = (licenseno) => {
    var regex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/;
    if (regex.test(licenseno)) {
      return true;
    } else {
      return false;
    }
  }
  const validateaadharno = (aadharno) => {
    var reg = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
    if (reg.test(aadharno)) {
      return true;
    } else {
      return false;
    }

  }
  const validateemail = (email) => {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    if (re.test(email)) {
      return true
    } else {
      return false
    }
  }
  const RegisterUser = async (type, id) => {

    if (name == "") {
      toast.error("Please Enter Driver Name")
    } else if (mobilenumber == "") {
      toast.error("Please Enter Driver Mobile Number")
    } else if (mobilenumber.length != 10) {
      toast.error("Please Enter Valid Mobile Number")


    } else if (email == "") {
      toast.error("Please Enter Driver Email")
    } else if (!validateemail(email)) {
      toast.error("Please Enter Valid Email")

    } else if (licensetype == "") {
      toast.error("Please Select Driver License Type")
    } else if (licenseno == "") {
      toast.error("Please Enter Driver License Number")
    } else if (!validatelicenseno(licenseno)) {
      toast.error("Please Enter Valid Driver License Number")
    } else if (aadharno == "") {
      toast.error("Please Enter Driver Aadhar Number")
    } else if (!validateaadharno(aadharno)) {
      toast.error("Please Enter Valid Driver Aadhar Number")
    } else if (dob == "") {
      toast.error("Please Enter Driver Date of Birth")
    } else {
      if (type == "new") {
        var driver_id = `Driver${randomUsername()}`
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .insert([
            { user_id: driver_id, user_name: name, user_type: "Driver", user_phone: parseInt("91" + mobilenumber), user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/driver/profile.jpg", user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          ])

        if (user !== null) {
          const { data, error } = await supabase
            .from('driver_details')
            .insert([
              { driver_id: driver_id, driver_email: email, createdBy: window.localStorage.getItem("useremail"), driver_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/driver/profile.jpg", driver_name: name, driver_phone: parseInt("91" + mobilenumber), driver_dob: dob, driver_aadhar_no: parseInt(aadharno), driver_licence: licenseno, driver_licensetype: licensetype },
            ])

          if (data !== null) {


            toast.success(`Driver Created Successfully`)
            setLarge(!Large)
            getDriverdetail()


          } else {
            toast.error(error.message)
          }
        } else {
          toast.error(error1.message)
        }
      } else {
        var driver_id = id
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .update(
            { user_name: name, user_type: "Driver", user_phone: parseInt("91" + mobilenumber), user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/driver/profile.jpg", user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          )
          .eq('user_id', driver_id)

        if (user !== null) {
          const { data, error } = await supabase
            .from('driver_details')
            .update(
              { driver_email: email, createdBy: window.localStorage.getItem("useremail"), driver_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/driver/profile.jpg", driver_name: name, driver_phone: parseInt("91" + mobilenumber), driver_dob: dob, driver_aadhar_no: parseInt(aadharno), driver_licence: licenseno, driver_licensetype: licensetype },
            )
            .eq('driver_id', driver_id)

          if (data !== null) {


            toast.success(`Driver Updated Successfully`)
            setLarge(!Large)
            getDriverdetail()


          } else {
            toast.error(error.message)
          }
        } else {
          toast.error(error1.message)
        }
      }
    }



  }
  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Driver Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">

            <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
              <ModalHeader toggle={LargeModaltoggle}>
                {edittype == "new" ? "Register" : "Update"} Here For  Driver
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col>

                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Driver Name<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="text" placeholder="Enter Driver Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">License Type<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <Input className="form-control" type="select" placeholder="Choose Your License Type" value={licensetype} onChange={(e) => { setlicensetype(e.target.value) }}>
                          <option value={""}>Choose Your License Type</option>
                          {license_type.map((data, i) => {

                            return (
                              <option key={i} value={data.license_type}>{data.license_type}</option>
                            )
                          })}
                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">License No<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="text" placeholder="Enter Your License No" value={licenseno} onChange={(e) => { setlicenseno(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                          </InputGroupAddon>
                          <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />
                        </InputGroup>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-0 mt-3">


                      <Button color="primary" className="btn-block" onClick={() => {
                        RegisterUser(edittype, editid)
                      }}>PROCEED </Button>
                    </FormGroup>





                  </Col>
                </Row>
              </ModalBody>
            </Modal>
            {window.innerWidth < 800 ? <>
              <div style={{ textAlign: "right", padding: "5px" }}>
                <button className='btn' style={{ fontSize: "13px", padding: "10px", boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)", borderRadius: "10px", backgroundColor: "#E50014", color: "white" }} onClick={() => {
                  LargeModaltoggle(); setedittype("new")
                  seteditid("")
                }}>Create Driver</button>
              </div>

              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll", padding: "5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">

                    {Driver_detail.length > 0 ? <>
                      {Driver_detail.map((data, i) => {
                        return (
                          <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                            <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                              <h5 className="mb-0" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>
                                      <div className="media-size-email"><img src={data.driver_pic} alt="buyer_image" height={"40px"} width={"40px"} style={{ borderRadius: "10px" }} />
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>

                                        <span style={{ display: "block" }}>{data.driver_name}</span>
                                        <span style={{ display: "block" }}>{data.driver_licensetype}</span>

                                      </div>


                                    </div>
                                  </div>



                                </Accordion.Toggle>
                                <div className="media-size-email" style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#dfffe4", padding: "5px", cursor: "pointer" }} onClick={() => {
                                  UpdateUser(data.driver_id)
                                }}><Icon icon="bxs:edit" color="darkgreen" width="30" height="30" /></div>
                                  &nbsp;
                                  <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#efc6ca", padding: "5px", cursor: "pointer" }} onClick={() => {
                                    DeleteUser(data.driver_id)
                                  }}><Icon icon="bi:trash" color="#E50014" width="25" height="25" /></div>



                                </div>
                              </h5>
                            </CardHeader>
                            <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                              <CardBody>
                                <div className="email-app-sidebar left-bookmark">
                                  <div className="media" >

                                    <div className="media-body" style={{ textAlign: "left" }}>

                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Phone</span>
                                      <span style={{ display: "block" }}>{data.driver_phone.toString().slice(2, 12)}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Email</span>
                                      <span style={{ display: "block" }}>{data.driver_email}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>License No</span>
                                      <span style={{ display: "block" }}>{data.driver_licence}</span>


                                    </div>
                                    <div className="media-body" style={{ textAlign: "left" }}>

                                      {/* <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle Number</span>
                                      <span style={{ display: "block" }}>{data.customer_vehiclenumber}</span> */}


                                    </div>


                                  </div>


                                </div>


                              </CardBody>
                            </Accordion.Collapse>
                          </Card>
                        )


                      })}</> : <Card>
                      <CardHeader >
                        <h5 className="mb-0">
                          <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                            No Record Found
                          </Accordion.Toggle>
                        </h5>
                      </CardHeader>
                    </Card>}
                  </div>

                </Accordion>
              </div></> :
              <Card>
                <CardHeader>
                  <button className='btn btn-primary' style={{ float: "right" }} onClick={() => {
                    LargeModaltoggle(); setedittype("new")
                    seteditid("")
                  }}>Create Driver</button>
                </CardHeader>
                <CardBody>
                  <div className="table-responsive ">
                    <Table>
                      <thead>
                        <tr style={{ textAlign: "center" }}>
                          <th scope="col">{"Sr.No"}</th>
                          <th scope="col">{"Driver Image"}</th>
                          <th scope="col">{"Driver Name"}</th>
                          <th scope="col">{"Driver Email"}</th>
                          <th scope="col">{"Driver Phone"}</th>

                          <th scope="col">{"Driver License Type"}</th>
                          <th scope="col">{"Driver License No"}</th>

                          {/* <th scope="col">{"Driver Aadhar No"}</th>
                      <th scope="col">{"Driver DOB"}</th> */}
                          <th scope="col">{"Action"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Driver_detail.length > 0 ? <>
                          {Driver_detail.map((data, i) => {
                            return (
                              <tr key={i} style={{ textAlign: "center" }}>
                                <th scope="row">{i + 1}</th>
                                <td><img src={data.driver_pic} alt="Driver_image" height={"40px"} width={"40px"} style={{ borderRadius: "10px" }} /></td>
                                <td>{data.driver_name}</td>
                                <td>{data.driver_email}</td>
                                <td>{data.driver_phone.toString().slice(2, 12)}</td>


                                <td>{data.driver_licensetype}</td>

                                <td>{data.driver_licence}</td>
                                {/* <td>{data.driver_aadhar_no}</td>
                            <td>{data.driver_dob}</td> */}
                                <td><button className='btn btn-warning' onClick={() => {
                                  UpdateUser(data.driver_id)
                                }}><i className='fa fa-edit '></i></button> &nbsp;<button className='btn btn-danger' onClick={() => {
                                  DeleteUser(data.driver_id)
                                }}><i className='fa fa-trash'></i></button></td>
                              </tr>
                            )
                          })}
                        </>
                          : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}


                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>}

          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default Driver;